import { queryOptions } from "@tanstack/react-query";
import { fetchOccPageData } from "./pageDataClient";
import { pageDataKeys } from "./pageDataKeys";
import type { PageInitialDataResult } from "./pageInitialDataTypes";
import type { RegisteredUserPageInitialData } from "./registeredUserPageInitialData";

export const registeredUserPageQueryOptions = () =>
  queryOptions({
    queryKey: pageDataKeys.page("registered/user"),
    queryFn: () => fetchOccPageData<PageInitialDataResult<RegisteredUserPageInitialData>>("/page-data/registered/user"),
    staleTime: 0,
    gcTime: 0,
    refetchOnWindowFocus: false,
    retry: 1,
  });
